import type { BoxProps } from '@chakra-ui/react';
import { Box, Flex, HStack, Text, VStack } from '@chakra-ui/react';
import type { AvatarProps } from '@halo/ui-chat-react';
import { Avatar, RippleEffect, ChatMetaHeader } from '@halo/ui-chat-react';

export interface GroupItemProps extends BoxProps {
  group_name?: string;
  member_num?: number;
  avatar: string;
  avatarProps?: AvatarProps;
  startElement?: React.ReactNode;
  endElement?: React.ReactNode;
  rippleEffect?: boolean;
  isDisabled?: boolean;
  showBorder?: boolean;
  hoverable?: boolean;
  hoverableRounded?: string;
  onAvatarClick?: () => void;
  onClick?: () => void;
}

export function GroupItemRender({
  group_name = '',
  member_num = 0,
  avatar,
  avatarProps,
  startElement,
  endElement,
  rippleEffect = true,
  isDisabled = false,
  showBorder = true,
  hoverable = true,
  hoverableRounded = 'initial',
  onAvatarClick,
  onClick,
}: GroupItemProps) {
  return (
    <RippleEffect w="full" enabled={rippleEffect}>
      <HStack
        px="2"
        pt="2"
        w="full"
        _hover={
          hoverable
            ? {
                bg: 'bg.subtle',
                rounded: hoverableRounded,
              }
            : undefined
        }
      >
        {startElement}
        <Box
          className="UserItem"
          flex="1"
          overflow="hidden"
          onClick={onClick}
          cursor={isDisabled ? 'not-allowed' : 'pointer'}
        >
          <HStack gap="2.5" flex="1" align="flex-start" fontSize="xs">
            <Avatar
              size="sm"
              src={avatar}
              activeShake={false}
              showUserError={false}
              onClick={onAvatarClick}
              {...avatarProps}
            />
            <Flex
              w="full"
              borderBottom={showBorder ? '1px' : '0'}
              borderStyle="solid"
              borderColor="border"
              align="center"
              flex="1"
              overflow="hidden"
            >
              <VStack
                flex="1"
                align="flex-start"
                justify="center"
                pb="2"
                gap="1"
                h="3em"
                lineHeight="1"
                boxSizing="content-box"
                w="full"
                css={{
                  '& > div': {
                    w: 'full',
                  },
                }}
                overflow="hidden"
              >
                <ChatMetaHeader
                  sessionName={group_name}
                  name={''}
                  isGroup={true}
                  updateAtDisplay=""
                />
                <Text fontWeight="medium" lineHeight="1" color="fg.muted" truncate>
                  {`${member_num} members`}
                </Text>
              </VStack>
              {endElement}
            </Flex>
          </HStack>
        </Box>
      </HStack>
    </RippleEffect>
  );
}
